import React, { useState } from 'react';
import { toast } from 'react-toastify';

const API_BASE = process.env.REACT_APP_API_BASE;

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleSubmit = async () => {
    if (!email) return toast.error('Please enter your email');
    if (!validateEmail(email)) return toast.error('Please enter a valid email address');

    setIsLoading(true);

    try {
      const res = await fetch(`${API_BASE}/api/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();
      if (res.ok) {
        toast.success(data.message);
      } else {
        toast.error(data.message || 'Failed to send reset email');
      }
    } catch (err) {
      toast.error('Something went wrong');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="w-full max-w-md p-6 bg-white rounded shadow-md">
        <div className="flex justify-center mb-6">
          <img src="/ennoverse.png" alt="Ennoverse Logo" className="h-10" />
        </div>
        <h2 className="text-xl font-semibold mb-4 text-center text-gray-700">
          Forgot Your Password?
        </h2>
        <p className="text-sm text-gray-600 text-center mb-4">
          Enter your email and we will send you a link to reset your password.
        </p>
        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full p-2 border rounded mb-4"
        />
        <button
          onClick={handleSubmit}
          disabled={isLoading}
          className="w-full bg-primary hover:bg-red-600 text-white py-2 rounded"
        >
          {isLoading ? 'Sending...' : 'Send Reset Link'}
        </button>
      </div>
    </div>
  );
}
